<div class="row">
  <div class="col-12 mb-14">
    <div class="d-flex align-items-center">
      <span style="font-size: 15px; line-height: 22px" class="fw-bold mr-6">{{ title }}</span>
      <p500-ui-dropdown class="c-dropdown c-dropdown--list" position="bottom" [hidden]="list.size === itemsList.size">
        <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
          <button type="button" p500-ui-circled-button size="small" color="primary" (click)="toggle()">
            <p500-ui-icon name="controls-plus"></p500-ui-icon>
          </button>
        </ng-template>
        <ng-template p500UIDropdownBody>
          <ng-container *ngFor="let item of list.values()">
            <ng-container *ngIf="!form.get(item.key)">
              <div p500UIDropdownItem class="c-dropdown__item" (click)="add(item.key)">
                <div class="c-dropdown__item-button">{{ item.label }}</div>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </p500-ui-dropdown>
    </div>
  </div>
</div>
<ng-container [formGroup]="form">
  <div class="row">
    <ng-container *ngFor="let item of itemsList.values()">
      <div class="c-form__section d-flex" [ngClass]="'col-' + item.col">
        <p500-ui-control-dynamic-component [component]="item.component" [settings]="item.settings" class="flex-1">
        </p500-ui-control-dynamic-component>
        <button
          *ngIf="!item.default"
          type="button"
          class="ml-10 mb-4 align-self-end"
          p500-ui-circled-button
          color="warn"
          size="medium"
          [transparent]="true"
          (click)="remove(item.key)"
        >
          <p500-ui-icon name="bin" size="12px"></p500-ui-icon>
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>
